export const createConversation = async (): Promise<{
  conversation_id: string;
} | null> => {
  try {
    const res = await fetch(
      `https://we-spoke-digital-ais-d-aca.mangosky-6149bdd4.westeurope.azurecontainerapps.io/api/agent/cody/conversations`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({}),
      }
    );
    if (!res.ok) throw new Error(await res.text());
    return await res.json();
  } catch (error) {
    console.error('createConversation() failed:', error);
    return null;
  }
};

export const sendMessageToApi = async (
  id: string,
  message: string
): Promise<any> => {
  try {
    const res = await fetch(
      `https://we-spoke-digital-ais-d-aca.mangosky-6149bdd4.westeurope.azurecontainerapps.io/api/agent/cody/conversations/${id}/messages`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message }),
      }
    );
    if (!res.ok) throw new Error(await res.text());
    return await res.json();
  } catch (error) {
    console.error('sendMessageToApi() failed:', error);
    throw error;
  }
};
